import Component from 'inferno-component';
import { Grid } from 'semantic-ui-react';

export default class CoverHeader extends Component {
    render() {
        return (
            <Grid>
                <Grid.Row centered>
                    <h1 className="cover-text uppercase">
                        Digitális egyetemi hirdetési hálózat
                    </h1>
                </Grid.Row>
                <Grid.Row centered className="cover-text">
                    <h3>
                        Brandépítés? Munkaerő toborzás? Hallgatóknak szóló kampányok? <br/>Szolgáltatások, termékek népszerűsítése?
                        Próbálja ki Ön is és élvezze a digitális reklámozás hatékonyságát!
                    </h3>
                </Grid.Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cover/CoverHeader.js